package br.com.heyagenda.domain.model

data class User(
    val uid: String,
    val name: String,
    val email: String,
    val studioName: String? = null,
    val specialty: String? = null,
    val photoUrl: String? = null,
    val slug: String? = null,
    val themeAccentColor: String? = null,
    val instagramHandle: String? = null,
    val address: String? = null,
    val announcementBanner: String? = null,
    val totalVisits: Long = 0L,
    val phone: String? = null,
    val subscriptionTier: String = "free",
    val subscriptionBillingCycle: String? = null,
    val subscriptionExpiresAt: Long? = null,
    val isFounderPromo: Boolean = true,
    val monthlyAppointmentsCount: Int = 0
) {
    val isPro: Boolean
        get() = subscriptionTier.equals("pro", ignoreCase = true)

    val currentTier: SubscriptionTier
        get() = SubscriptionTier.fromId(subscriptionTier)
}
